import styled, { keyframes } from "styled-components";

export const TitleH1 = styled.h1`
  text-align: center;
  font-size: 54px;
  font-weight: 600;
  position: relative;
  margin-bottom: 0px;
`;

export const Discription = styled.h2`
  border: 1px solid black;
`;

export const BiggerTextInvoice = styled.strong`
  font-size: 28px;
  font-weight: 500;
`;

export const SpanDescription = styled.strong`
  font-size: 26px;
  font-weight: 500;
  text-align: center;
`;

export const SpanDescriptionBold = styled.strong`
  font-size: 26px;
  font-weight: 700;
  text-align: center;
`;

export const PaymentVoucherImage = styled.img`
  width: 700px;
  height: 280px;
`;

export const Icon = styled.img`
  height: 200px;
  width: 200px;
`;

export const TitleFaturaTextValue = styled.span`
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  width: 50%;

  @media print {
    font-size: 9pt;
  }
`;

export const DateFaturaTextValue = styled.span`
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  width: 50%;
  display: flex;
  justify-content: flex-end;

  @media print {
    font-size: 8pt;
  }
`;

export const SpanTextTitleBold = styled.span`
  color: #000;
  font-weight: bold;
  font-size: 14px;

  @media print {
    font-size: 8pt;
  }
`;

export const SpanTextTitle = styled.span`
  color: #000;
  font-size: 14px;

  @media print {
    font-size: 9pt;
  }
`;

export const Dividers = styled.hr`
  border-top: 3px dashed #7c7c7c;
  width: 100%;
  height: 1px;

  @media print {
    border-top: 1px solid #000;
  }
`;

export const SpanTextValue = styled.span`
  color: #000;
  font-size: 12px;
  font-weight: 600;
  width: 50px;

  @media print {
    font-size: 7pt;
  }
`;

export const SpanTextTitleDataBold = styled.span`
  color: #707070;
  font-weight: bold;
  font-size: 13px;
  margin-left: 1%;

  @media print {
    margin-left: 0;
    color: #000;
    font-size: 7pt;
  }
`;

export const SpanTextValueTitlePayment = styled.span`
  color: #1feb52;
  font-size: 12px;
  margin-left: 3%;
  width: 100%;

  @media print {
    font-size: 8pt;
    width: 350px;
    margin-left: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #000;
  }
`;

export const SpanTextValuePayment = styled.span`
  color: #1feb52;
  font-size: 12px;
  font-weight: 600;
  width: 50px;

  @media print {
    font-size: 7pt;
    color: #000;
  }
`;

export const SpanTextValueTitle = styled.span`
  color: #000;
  font-size: 12px;
  margin-left: 3%;
  width: 100%;

  @media print {
    font-size: 8pt;
    width: 350px;
    margin-left: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const animation = keyframes`
  to {
    opacity: 0;
  }
`;

export const DivAnimation = styled.div`
  animation: ${animation} 4s linear infinite;
  align-items: center;
  justify-content: center;
`;

export const PrintContainer = styled.div`
  background: white;
  > iframe {
    height: 280px;
    width: 700px;
    background: white !important;
  }

  @page {
    margin: 1cm;
    size: A4;
    background: white !important;
  }
  @media print {
    background: white !important;

    iframe {
      height: 1000px !important;
      width: 700px;
      background: white !important;
    }
    border: none !important;
    color: #000 !important;
    text-shadow: none !important;
    filter: none !important;
    -ms-filter: none !important;
    overflow: auto;
  }
`;
